import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

export interface GlobalEventType {
  type:string;
  data:any;
}

@Injectable({
  providedIn: 'root'
})
export class GlobalEventServiceService {

  eventSub = new Subject<GlobalEventType>();
  constructor() { }

  sendEvent(type: string, data: any) {
    this.eventSub.next({
      type,
      data
    });
  }

  listen(eventName?: string): Observable<GlobalEventType> {
    const res = this.eventSub.asObservable();
    if (!eventName) {
      return res;
    }
    return res.pipe(filter((val: GlobalEventType) => {
      return val.type === eventName;
    })
    );
  }
}
